import { render, staticRenderFns } from "./IndicesCiudad.vue?vue&type=template&id=771b86b2"
import script from "./IndicesCiudad.vue?vue&type=script&lang=js"
export * from "./IndicesCiudad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports